export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
  ? process.env.REACT_APP_BACKEND_URL
  : "";
export const LANDING_URL = process.env.REACT_APP_LANDING_URL
  ? process.env.REACT_APP_LANDING_URL
  : "";
export const SALARY_LOAN_ID = process.env.REACT_APP_SALARY_LOAN_ID
  ? process.env.REACT_APP_SALARY_LOAN_ID
  : "";
export const SALARY_LOAN_PERIOD = process.env.REACT_APP_SALARY_LOAN_PERIOD
  ? process.env.REACT_APP_SALARY_LOAN_PERIOD
  : "";
